<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {},
  name: 'App'
}
</script>
